/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { type LatestReleaseResource, type DashboardResource, TaskState } from "@octopusdeploy/octopus-server-client";
import moment from "moment";
class CurrentVersionMap {
    private environmentVersionMap: Map<string, string>;
    private tenantEnvironmentVersionMap: Map<string, Map<string, string>>;
    constructor(environmentVersionMap: Map<string, string>, tenantEnvironmentVersionMap: Map<string, Map<string, string>>) {
        this.environmentVersionMap = environmentVersionMap;
        this.tenantEnvironmentVersionMap = tenantEnvironmentVersionMap;
    }
    static CreateFromDashboard(dashboard: DashboardResource): CurrentVersionMap {
        const environmentVersionMap = new Map<string, string>();
        const tenantEnvironmentVersionMap = new Map<string, Map<string, string>>();
        for (const item of dashboard.Items) {
            if (item.TenantId) {
                if (!tenantEnvironmentVersionMap.has(item.TenantId)) {
                    tenantEnvironmentVersionMap.set(item.TenantId, new Map<string, string>());
                }
                tenantEnvironmentVersionMap.get(item.TenantId)!.set(item.EnvironmentId, item.ReleaseVersion);
            }
            else {
                environmentVersionMap.set(item.EnvironmentId, item.ReleaseVersion);
            }
        }
        return new CurrentVersionMap(environmentVersionMap, tenantEnvironmentVersionMap);
    }
    static CreateFromLatestReleases(latestReleases: LatestReleaseResource[]): CurrentVersionMap {
        const successfulReleases = latestReleases.filter((item) => item.State === TaskState.Success);
        const environmentVersionMap = new Map<string, string>();
        const tenantEnvironmentVersionMap = new Map<string, Map<string, string>>();
        // Ensure all CompletedTime values are Moment objects
        successfulReleases.forEach((item: LatestReleaseResource) => {
            if (item.CompletedTime && !moment.isMoment(item.CompletedTime)) {
                item.CompletedTime = moment(item.CompletedTime);
            }
        });
        // Sort releases from oldest to newest, placing items without CompletedTime at the end
        const sortedReleases = successfulReleases.sort((a: LatestReleaseResource, b: LatestReleaseResource) => {
            if (!a.CompletedTime)
                return 1;
            if (!b.CompletedTime)
                return -1;
            return a.CompletedTime.diff(b.CompletedTime);
        });
        // Process releases in order (oldest to newest) so we end up with the latest version
        for (const item of sortedReleases) {
            if (item.TenantId) {
                if (!tenantEnvironmentVersionMap.has(item.TenantId)) {
                    tenantEnvironmentVersionMap.set(item.TenantId, new Map<string, string>());
                }
                tenantEnvironmentVersionMap.get(item.TenantId)!.set(item.EnvironmentId, item.ReleaseVersion);
            }
            else {
                environmentVersionMap.set(item.EnvironmentId, item.ReleaseVersion);
            }
        }
        return new CurrentVersionMap(environmentVersionMap, tenantEnvironmentVersionMap);
    }
    getCurrentRelease(environmentId: string, tenantId?: string) {
        if (tenantId) {
            return this.tenantEnvironmentVersionMap.has(tenantId) ? this.tenantEnvironmentVersionMap.get(tenantId)!.get(environmentId) : null;
        }
        return this.environmentVersionMap.get(environmentId);
    }
}
export default CurrentVersionMap;
